const keyboardDatePickerActionModalFilter = {
  from: 'De',
  to: 'Hasta'
};

export default keyboardDatePickerActionModalFilter;
